export enum StepState {
  CURRENT = "CURRENT",
  FINISHED = "FINISHED",
  NOT_STARTED = "NOT_STARTED",
}

export interface StepperStep {
  id: string;
  label: string;
  icon: React.ReactNode;
  state: StepState;
}

export interface StepperProps {
  steps: StepperStep[];
}
